import {
  FETCH_CAMPAIGN,
  FETCH_CAMPAIGN_SUCCESS,
  FETCH_CAMPAIGN_ERROR,
  ADD_CAMPAIGN,
  ADD_CAMPAIGN_SUCCESS,
  ADD_CAMPAIGN_ERROR,
  RESET_ADD_CAMPAIGN,
  UPDATE_CAMPAIGN,
  UPDATE_CAMPAIGN_SUCCESS,
  UPDATE_CAMPAIGN_ERROR,
  DELETE_CAMPAIGN,
  DELETE_CAMPAIGN_SUCCESS,
  DELETE_CAMPAIGN_ERROR,
} from "constants/ActionTypes";

export const fetchCampaign = (params) => {
  return {
    type: FETCH_CAMPAIGN,
    params,
  }
};

export const fetchCampaignSuccess = (campaignList) => {
  return {
    type: FETCH_CAMPAIGN_SUCCESS,
    payload: campaignList,
  }
};

export const fetchCampaignError = (error) => {
  return {
    type: FETCH_CAMPAIGN_ERROR,
    payload: error
  }
};

export const addCampaign = (payload) => {
  return {
    type: ADD_CAMPAIGN,
    payload,
  }
};

export const addCampaignSuccess = (payload) => {
  return {
    type: ADD_CAMPAIGN_SUCCESS,
    payload,
  }
};

export const addCampaignError = (error) => {
  return {
    type: ADD_CAMPAIGN_ERROR,
    payload: error
  }
};

export const updateCampaign = (payload) => {
  return {
    type: UPDATE_CAMPAIGN,
    payload,
  }
};

export const updateCampaignSuccess = (payload) => {
  return {
    type: UPDATE_CAMPAIGN_SUCCESS,
    payload,
  }
};

export const updateCampaignError = (error) => {
  return {
    type: UPDATE_CAMPAIGN_ERROR,
    payload: error
  }
};

export const deleteCampaign = (payload) => {
  return {
    type: DELETE_CAMPAIGN,
    payload,
  }
};

export const deleteCampaignSuccess = (payload) => {
  return {
    type: DELETE_CAMPAIGN_SUCCESS,
    payload,
  }
};

export const deleteCampaignError = (error) => {
  return {
    type: DELETE_CAMPAIGN_ERROR,
    payload: error
  }
};

export const resetAddCampaign = () => {
  return {
    type: RESET_ADD_CAMPAIGN,
  }
};
